export function isFirstSkill(item) {
    return item.preSkillIds.length === 0;
}

// Alfa vyšší (méně průhledné) u základních ("first") skillů než u navazujících - odlišuje je vizuálně v seznamu.
export function getRgba(color, item) {
    const RGB = color;
    const A = (isFirstSkill(item) / 4 + 0.4) * 1.2;
    return 'rgba(' + parseInt(RGB.substring(1, 3), 16) + ',' + parseInt(RGB.substring(3, 5), 16) + ',' + parseInt(RGB.substring(5, 7), 16) + ',' + A + ')';
}

// Stejný odstín jako getRgba, ale jako plná (neprůhledná) barva pro popupy, kam nesmí nic prosvítat -
// blenduje k bílé v light theme, k černé v dark theme.
export function getSolidTint(color, dark) {
    const A = dark ? 0.75 : 0.65;
    const target = dark ? 0 : 255;
    const blend = (channel) => Math.round(A * channel + (1 - A) * target);
    const r = blend(parseInt(color.substring(1, 3), 16));
    const g = blend(parseInt(color.substring(3, 5), 16));
    const b = blend(parseInt(color.substring(5, 7), 16));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
}

export function useIcon(item) {
    if (!item.defence) return 'mdi-sword-cross';
    return item.defence > 1 ? 'mdi-shield-half-full' : 'mdi-laser-pointer';
}

export function useLabel(item) {
    if (!item.defence) return 'Attack';
    return item.defence > 1 ? 'Shield' : 'Dodge';
}

// Průnik skill.id s obstacleType.travellingSkillIds - které známé obstacle typy tenhle skill rozbíjí.
export function getKnownObstacleBreaks(skill, knownObstacleTypes) {
    if (!skill || !knownObstacleTypes) {
        return [];
    }
    return knownObstacleTypes.filter((ot) => ot.travellingSkillIds && ot.travellingSkillIds.includes(skill.id));
}

export const EFFECT_ICONS = {
    HEAL: 'mdi-heart-plus',
    PIERCING: 'mdi-spear',
    LUNGE: 'mdi-gavel',
    REFLECT: 'mdi-mirror',
    STUN: 'mdi-head-flash-outline',
    METRONOM: 'mdi-metronome',
    LIFESTEAL: 'mdi-heart-flash',
};

export function effectIcon(item) {
    if (!item || !item.effect) return null;
    return EFFECT_ICONS[item.effect] || null;
}

// Server (FightReport2) má pro defSkill jen REFLECT nebo bez efektu - STUN/HEAL/LIFESTEAL/PIERCING/LUNGE
// jsou vždy vázané na attSkill, nikdy na defSkill. `t` je i18n translate fn ($t z volající komponenty) -
// text je součástí client/src/i18n/locales/*/pokedex.json (skillDetail.defenceExplain*), ne natvrdo tady.
export function getDefenceExplanation(item, t) {
    if (!item || !item.defence) return null;
    if (item.effect === 'REFLECT') {
        return t('pokedex.skillDetail.defenceExplainReflect', {percentage: item.percentage});
    }
    return t('pokedex.skillDetail.defenceExplainPlain');
}

// Server (FightService::fightPokemons2) nedovolí řetězit stuny - je-li soupeř už stunnutý,
// další STUN skill nedělá žádný nový pokus. `t` viz getDefenceExplanation výše.
export function getStunExplanation(item, t) {
    if (!item || item.effect !== 'STUN') return null;
    return t('pokedex.skillDetail.stunExplain');
}

export function getEffectFormula(item) {
    let name = item.effect ? item.effect : '';
    let value = item.effect ? item.percentage + '%' : '';
    if (item.effect && ['LUNGE', 'PIERCING', 'SELFHARM'].includes(item.effect)) {
        let symbol = item.effectBonus < 0 ? '-' : '+';
        value = symbol + item.effectBonus;
    } else if (item.effect && ['METRONOM'].includes(item.effect)) {
        return item.effect;
    }
    return name + ' ' + value;
}

// Jen číselná hodnota efektu bez názvu - má smysl jen tam, kde effectIcon() už dává ikonku.
export function effectValue(item) {
    if (!item || !item.effect) return '';
    if (['LUNGE', 'PIERCING', 'SELFHARM'].includes(item.effect)) {
        const symbol = item.effectBonus < 0 ? '-' : '+';
        return symbol + item.effectBonus;
    }
    if (item.effect === 'METRONOM') return '';
    return item.percentage + '%';
}

// HP prahy pro efekty, ktere davaji smysl jen kdyz je pokemon zraneny (zadani
// uzivatele 2026-08-21 - heal az od 2/3 zivota, lifesteal uz od 3/4 - mensi
// vyhoda, hodi se nabidnout drive nez cisty heal). Sdilene mezi
// SkillPickerDialog.vue (predvyber filtrovaciho tagu) a BattleScreen.vue/
// PvpBattleScreen.vue (auto-vyber "nejsilnejsiho" skillu do action baru,
// zadani uzivatele 2026-08-28 - "protoze moje nejsilnejsi skill je heal, tak
// se predvybere v picker, ale dokud nemam pod prah zivotu, tak by se mel z
// predvyberu ignorovat") - obe misto resi stejnou otazku "je tenhle efekt pri
// aktualnim HP vubec relevantni". Zapsano jako [citatel, jmenovatel] (hp *
// jmenovatel <= maxHp * citatel), aby porovnani nesahalo na plovouci
// desetinna cisla.
export const HP_GATED_EFFECT_THRESHOLDS = {
    HEAL: [2, 3],
    LIFESTEAL: [3, 4],
};

// True, kdyz efekt neni HP-gated vubec (normalni utok, STUN, ...), nebo kdyz
// je gated a aktualni HP uz je pod prahem. hp/maxHp null/0 (obstacle mod,
// data jeste nenactena) = gate se nikdy nesplni, aby se heal/lifesteal
// nevybiraly naslepo bez znalosti skutecneho zivota.
export function isHpGateSatisfied(effect, hp, maxHp) {
    const threshold = HP_GATED_EFFECT_THRESHOLDS[effect];
    if (!threshold) {
        return true;
    }
    if (hp === null || hp === undefined || !maxHp) {
        return false;
    }
    const [numerator, denominator] = threshold;
    return hp * denominator <= maxHp * numerator;
}
